// extracted by mini-css-extract-plugin
export default {"container":"dcc_anchorNavigation-container","label":"dcc_anchorNavigation-label"};